import { CircularProgressbarWithChildren } from 'react-circular-progressbar'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { hexToRgb } from 'utils/colors'

import Panel from 'components/Panel'

import 'react-circular-progressbar/dist/styles.css'

interface PropsCircularProgress {
  title?: string
  description?: string
  value?: number
  isActive?: boolean
}

const defaultProps: PropsCircularProgress = {
  title: '',
  description: '',
  value: 0,
  isActive: false,
}

const colorProgress = hexToRgb('#0B5AE2')

const CircularProgress = ({
  title = defaultProps.title,
  description = defaultProps.description,
  value = defaultProps.value,
  isActive = defaultProps.isActive,
}: PropsCircularProgress = defaultProps) => {
  return (
    <Panel
      isActive={isActive}
      className="flex items-center p-6"
      data-testid={`circularProgress-${title}`}
    >
      <div className="w-[84px]">
        <CircularProgressbarWithChildren
          minValue={-1}
          value={value}
          styles={{
            path: {
              stroke: colorProgress,
              strokeLinecap: 'round',
            },
          }}
        >
          {!isActive ? (
            <Icon color="disabled" data-testid="lock-icon">
              lock
            </Icon>
          ) : (
            <Text variant="heading-md" color="primary">
              {value}%
            </Text>
          )}
        </CircularProgressbarWithChildren>
      </div>
      <div className="ml-4">
        <Text variant="heading-sm" color={!isActive ? 'subdued' : 'default'}>
          {title}
        </Text>
        <Text
          color="subdued"
          className="mt-1"
          data-testid={`circularProgress-${title}-description`}
        >
          {description}
        </Text>
      </div>
    </Panel>
  )
}

export default CircularProgress
